<template>
  <div class="prode-mundial">
    <v-app>
      <!-- Header -->
      <v-card class="header-card" dark>
        <v-card-title class="justify-center flex-column pa-3">
          <div class="text-h6 font-weight-bold text-center">
            ⚽ CARGA DE RESULTADOS - MUNDIAL 2026
          </div>
          <div class="text-caption text-center mt-1" style="opacity: 0.8;">
            Responsable: {{ responsable }}
          </div>
        </v-card-title>
      </v-card>

      <!-- Selector de Grupo -->
      <v-card class="mt-1 pa-2" elevation="1">
        <div class="d-flex flex-wrap justify-center" style="gap: 4px;">
          <v-btn
            v-for="grupo in grupos"
            :key="grupo"
            :color="grupoActivo === grupo ? 'deep-purple darken-1' : 'grey lighten-2'"
            :dark="grupoActivo === grupo"
            x-small depressed class="grupo-btn"
            @click="grupoActivo = grupo"
          >
            {{ grupo }}
          </v-btn>
        </div>
      </v-card>

      <!-- Partidos del grupo -->
      <v-card class="mt-1 pa-2" elevation="1">
        <div class="text-subtitle-2 font-weight-bold text-center mb-2 deep-purple--text">
          GRUPO {{ grupoActivo }}
        </div>

        <div v-for="(partido, idx) in partidosGrupoActivo" :key="idx" class="partido-row">
          <v-row dense align="center" class="ma-0">
            <v-col cols="4" class="text-right pr-1">
              <div class="equipo-nombre">{{ partido.equipo1 }}</div>
            </v-col>

            <v-col cols="4" class="d-flex align-center justify-center" style="gap: 6px;">
              <v-text-field
                v-model="partido.goles1"
                dense outlined hide-details
                type="number" min="0" max="9"
                class="gol-input"
              />
              <span class="font-weight-bold grey--text">-</span>
              <v-text-field
                v-model="partido.goles2"
                dense outlined hide-details
                type="number" min="0" max="9"
                class="gol-input"
              />
            </v-col>

            <v-col cols="4" class="text-left pl-1">
              <div class="equipo-nombre">{{ partido.equipo2 }}</div>
            </v-col>
          </v-row>

          <div class="text-center text-caption grey--text" style="font-size: 0.65rem !important;">
            {{ partido.fechaPartido }} · {{ partido.sede }}
          </div>

          <v-divider v-if="idx < partidosGrupoActivo.length - 1" class="my-1" />
        </div>
      </v-card>

      <!-- Guardar -->
      <v-card class="mt-1 pa-3" elevation="1">
        <v-row dense justify="end">
          <v-col cols="auto">
            <v-btn color="success" :loading="guardando" @click="guardarResultados">
              <v-icon left>mdi-content-save</v-icon>
              Guardar Resultados
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import axios from "../../../axios-auth";
import moment from "moment";

export default {
  name: "ProdeCargaResultado2026",

  data() {
    return {
      responsable: "",
      grupoActivo: "A",
      grupos: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      partidos: [],
      guardando: false,
    };
  },

  computed: {
    partidosGrupoActivo() {
      return this.partidos.filter((p) => p.grupo === this.grupoActivo);
    },

    accesoPermitido() {
      // Solo mprieto puede cargar resultados, y a partir del 11/06/2026
      const usuario = this.$store.state.usuario ? this.$store.state.usuario.toString().trim() : "";
      const habilitado = moment().isSameOrAfter(moment("2026-06-11 00:00", "YYYY-MM-DD HH:mm"));
      return usuario === "mprieto" && habilitado;
    },
  },

  mounted() {
    this.responsable = this.$store.state.nombre ? this.$store.state.nombre.toString().trim() : "";
    if (!this.accesoPermitido) {
      this.$swal({
        icon: "warning",
        title: "Acceso no disponible",
        text: "La carga de resultados estará disponible para el responsable a partir del 11/06/2026.",
        confirmButtonText: "Entendido",
      });
      this.$router.push({ name: "ProdeFixture2026" });
      return;
    }
    this.cargarResultados();
  },

  methods: {
    cargarResultados() {
      axios
        .get("/App/GetResultados2026")
        .then((r) => {
          this.partidos = (r.data || []).map((p) => ({
            ...p,
            goles1: p.goles1 || "",
            goles2: p.goles2 || "",
          }));
        })
        .catch(() => { this.partidos = []; });
    },

    guardarResultados() {
      this.$swal({
        title: "Guardar Resultados",
        text: "¿Desea guardar los resultados oficiales?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        background: "#ececec",
      }).then((result) => {
        if (result.value) {
          const resultados = this.partidos
            .filter((p) => p.goles1 !== "" && p.goles1 !== null)
            .map((p) => ({
              id: p.idresultado,
              goles1: p.goles1.toString(),
              goles2: p.goles2.toString(),
            }));

          this.guardando = true;

          axios
            .post("/App/GuardarResultado2026", resultados)
            .then(() => {
              this.$swal({ icon: "success", title: "Resultados guardados", showConfirmButton: false, background: "#ececec", timer: 3000 });
            })
            .catch(() => {
              this.$swal({ icon: "error", title: "Error al guardar", toast: true, position: "top-end", showConfirmButton: false, timer: 3000 });
            })
            .finally(() => { this.guardando = false; });
        }
      });
    },
  },
};
</script>

<style scoped>
.prode-mundial {
  max-width: 600px;
  margin: 0 auto;
}

.header-card {
  background: linear-gradient(135deg, #4a148c 0%, #6a1b9a 50%, #7b1fa2 100%) !important;
}

.grupo-btn {
  min-width: 32px !important;
  padding: 0 6px !important;
  font-size: 0.7rem !important;
  font-weight: 700;
}

.equipo-nombre {
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
}

.gol-input {
  max-width: 44px;
}

.gol-input :deep(.v-input__slot) {
  min-height: 32px !important;
  padding: 0 6px !important;
}

.gol-input :deep(input) {
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  padding: 4px 0 !important;
}

.gol-input :deep(input[type="number"]::-webkit-inner-spin-button),
.gol-input :deep(input[type="number"]::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
.gol-input :deep(input[type="number"]) {
  -moz-appearance: textfield;
}
</style>
